import { render, staticRenderFns } from "./ProductNreiGeneral.vue?vue&type=template&id=65dc774e&"
import script from "./ProductNreiGeneral.vue?vue&type=script&lang=ts&"
export * from "./ProductNreiGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports